const defaultHandle = function defaultHandle(response) {
    const statusDictionary = [
        400, 401, 402, 403, 404, 408, 412, 413, 415, 500, 501, 504, 505,
    ],
        ErrorMessageDictionary = [
            "Bad Request!",// 400          
            "Unauthorized: Access is denied due to invalid credentials.",  //401   
            "Payment Required", //402      
            "Forbidden! You do not have permission to access the resource you requested.", //403           
            "Not Found!  The requested URL or resource was not found on this server.",// 404
            "HTTP Request Timeout!  This request takes too long to process, it is timed out by the server.", //408
            "Precondition Failed!", //412
            "Payload Too Large!  The request is larger than the server is willing or able to process.That's all we know.", //413
            "Unsupported Media Type!  The server refused this request because the request entity is in a format ", //415
            "Internal Server Error!  There is a problem with the resource you are looking for, and it cannot be displayed.",// 500
            "Not Implemented Error!  The server is unable to process your request.",// 501         
            "Gateway Timeout!  The server encountered a temporary error and could not complete your request." +
            " Please try again later.", //504
            "Unknown Error! There is uncaught error occured.That's all we know.", //505
        ],
        errorDictionary = {};
    for (let i = 0; i < statusDictionary.length; i += 1) {
        errorDictionary[statusDictionary[i]] = ErrorMessageDictionary[i];
    }
    if (response.status >= 400) {
        return errorDictionary[response.status];
    }
    return response;
};
export default function ErrorException(response) {
    let errorResponse = "Internal Server errors. Check Logs!"; 
    if (response == undefined || null) {
        errorResponse = "Network Error or Gateway Timeout!  The server encountered a temporary error and could not complete your request. Please try again later."
        throw Error(errorResponse);
    }
    if (response.status >= 400) {      
        const defaultErrorMessage = defaultHandle(response);
        if (defaultErrorMessage) {
            errorResponse = response.data.message ? response.data.message : defaultErrorMessage;
        }
        throw Error(errorResponse);
    }
}
